// extracted by mini-css-extract-plugin
export default {"main":"GridItem_main__O35n2","gridIcon":"GridItem_gridIcon__Ecz2e","gridTitle":"GridItem_gridTitle__W6w44","gridInfo":"GridItem_gridInfo__SxSL8","yourImc":"GridItem_yourImc__SYVoT"};